//Actual 'Galaxy Note Three 7 inch' max-width:1024px. Using 1750px to make site more dynamic in general
export const galaxyNoteThreeDimensions = '(max-width:1750px), (max-height:600px)';

export const transportBookingFormPrefix = 'TBF';

export const ftlPrefix = 'MRL';
